/*
 *
 * Pages constants
 *
 */
export const LOAD_FAQ_PAGE = 'rewardsStore/FaqPageDynamic/LOAD_FAQ_PAGE';
export const LOAD_FAQ_PAGE_SUCCESS = 'rewardsStore/FaqPageDynamic/LOAD_FAQ_PAGE_SUCCESS';
export const LOAD_FAQ_PAGE_ERROR = 'rewardsStore/FaqPageDynamic/LOAD_FAQ_PAGE_ERROR';
